import isFunction from "mn-utils/isFunction";
import * as links from '../../../constants/links';
import {replaceLocation} from '../../../router';
import {USER_TYPE_MERCHANT} from '../../../constants/userTypes';

const userType = USER_TYPE_MERCHANT;

export default [
  [`^${links.LINK_REFERRAL}/?$`, () => {
    replaceLocation({
      path: links.LINK_REFERRAL_DASHBOARD,
    });
  }],
  [`^${links.LINK_REFERRAL_DASHBOARD}/?$`, {
    title: 'Referral Dashboard',
    main: require('../../../components/pages/Referral/Dashboard'),
    v2: 1,
  }],
  [`^${links.LINK_REFERRAL_MERCHANTS}/?$`, {
    title: 'Referral Merchants List',
    main: require('../../../components/pages/Referral/MerchantsList'),
    v2: 1,
  }],
  [`^${links.LINK_REFERRAL_ADD_MERCHANT}/?$`, {
    title: 'Referral Merchant Add',
    main: require('../../../components/pages/Referral/MerchantsAdd'),
    v2: 1,
  }],
  [`^${links.LINK_REFERRAL_TRX_ROOT}/?$`, {
    title: 'Referral Trx Details',
    main: require('../../../components/pages/Referral/TrxDetails'),
    v2: 1,
  }],
  [`^${links.LINK_REFERRAL_PAYOUT}/?$`, {
    title: 'Referral Payout',
    main: require('../../../components/pages/Referral/Payout'),
    v2: 1,
  }]
].map(([url, data]) => [url, isFunction(data) ? data : {...data, userType}]);
